const modifySubmissionWebLink = function (
  { commit, dispatch },
  { id, field, value }
) {
  commit("UPDATE_SUBMISSION_WEBLINK", { id, field, value });
  dispatch("validateSubmission");
};

export default modifySubmissionWebLink;
